var map = {
	"./banner-unico.png": [
		824,
		4
	],
	"./banners-col.png": [
		825,
		5
	],
	"./banners-mosaic.png": [
		826,
		6
	],
	"./card.png": [
		827,
		7
	],
	"./carrossel-de-banner.png": [
		828,
		8
	],
	"./carrossel-de-produtos-query.png": [
		829,
		9
	],
	"./carrossel-de-produtos.png": [
		830,
		10
	],
	"./carrossel-de-stories.png": [
		831,
		11
	],
	"./colapse.png": [
		832,
		12
	],
	"./colecao-vtex.png": [
		833,
		13
	],
	"./default-preview.png": [
		834,
		14
	],
	"./description.png": [
		835,
		15
	],
	"./focus.png": [
		836,
		16
	],
	"./highlight-filter.png": [
		837,
		17
	],
	"./infinite-scroll.png": [
		838,
		18
	],
	"./logo.png": [
		839,
		19
	],
	"./media-youtube.png": [
		840,
		20
	],
	"./placeholder.png": [
		841,
		21
	],
	"./promocional-carrossel-de-banner.png": [
		842,
		22
	],
	"./redirect-menu.png": [
		843,
		23
	],
	"./redirect-title.png": [
		844,
		24
	],
	"./small-logo.png": [
		845,
		25
	],
	"./table-products.png": [
		846,
		26
	],
	"./topic.png": [
		847,
		27
	],
	"./unique-product.png": [
		848,
		28
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 815;
module.exports = webpackAsyncContext;